module.exports = __webpack_public_path__ + "img/bg.1dc42614.png";